<app-page-header routerLink="/" origin="Home" title="Bestellingen" [showAddButton]="true"
  (buttonClicked)="openModal(null)"></app-page-header>
<div class="container-full">
  <app-table-guru [apiEndpoint]="'/office/orders'" [enableFilters]="true" [columnMapping]="[
    { key: 'number', label: 'Bestelnummer' },
    { key: 'organisation_name', label: 'School' },
    { key: 'name', label: 'Contact persoon' },
    { key: 'period.name', label: 'Periode' },
    { key: 'department_number', label: 'Vestigingscode', type: 'organisation' },
    { key: 'order_type', label: 'Platform' },
    { key: 'created_at', label: 'Tijdstip', type: 'simpleDateTime' },
    { key: 'status', label: 'Status', type: 'statusText' },
    { key: 'print_status', label: 'Printstatus', type: 'statusText' }
  ]" [itemsPerPage]="25" [viewURL]="'/orders/details/'" [openModalComponent]="addFormReference" [reload]="reloadItems"
    class="compact">
  </app-table-guru>
</div>